import { FC, useRef } from "react"
import writeXlsxFile from "write-excel-file"
import BaseApi from "../../../api/api"
import { IRecodeOzonKatrenItem } from "../../FormKatrenOrder/FormKatrenOrder"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import { Button } from "@radix-ui/themes"

export const DownloadRecodeOzonBtn: FC = () => {
  const onClick = useRef(async () => {
    try {
      const { success, items } = await BaseApi.loadOzonRecodeKatren()
      if (success) {
        writeXlsxFile(items, {
          schema: RECODE_SCHEMA,
          fileName: "recodeOzon.xlsx",
        })
      } else {
        NotificationService.showNotification({
          level: "error",
          message: "Произошла ошибка",
        })
      }
    } catch (e) {}
  })
  return <Button onClick={onClick.current}>Скачать перекодировку</Button>
}

const RECODE_SCHEMA = [
  {
    column: "name",
    value: (item: IRecodeOzonKatrenItem) => item.name,
  },
  {
    column: "offer_id",
    value: (item: IRecodeOzonKatrenItem) => item.offer_id,
  },
  {
    column: "product_id",
    value: (item: IRecodeOzonKatrenItem) => item.product_id,
  },
  {
    column: "count",
    value: (item: IRecodeOzonKatrenItem) => item.count,
  },
]
